import { render, staticRenderFns } from "./InsightsBuilder.vue?vue&type=template&id=48649094&scoped=true"
import script from "./InsightsBuilder.vue?vue&type=script&lang=js"
export * from "./InsightsBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48649094",
  null
  
)

export default component.exports